import React from 'react'

function Technology() {
  return (
    <div className='w-full lg:w-[60%] min-h-screen py-12 lg:py-20 px-6 lg:px-20 bg-white relative lg:left-[270px]'>
        <p className='w-full text-black text-sm text-left py-2'>
            I have been exploring and practising technology since my schooling which helped me to solve problems I had came across.
        </p>
        <div className='w-full flex flex-col items-center py-2'>
            <p className='w-full text-black text-sm text-left py-2 mb-4'>
                I have been developing softwares for more than 4 years. <b>Python/JavaScript/C#</b> and its frameworks really made me excited on what it could do.
            </p>
            <div className='w-full grid grid-cols-1 lg:grid-cols-2 gap-4'>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To build a web site from stratch, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>JavaScript</li>
                        <li>CSS</li>
                        <li>HTML5</li>
                        <li>Jquery</li>
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To build a web site using frameworks, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>React</li>
                        <li>Angular</li>
                        <li>NextJS</li>
                        {/* <li>Vue</li> */}
                    </ul>
                </div>
                 <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To use css frameworks, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>TailwindCSS</li>
                        <li>Material UI</li>
                        <li>Ant Design</li>
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To build a rest-apis or server-side application, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>NodeJS</li>
                        <li>Python</li>
                        <li>C#</li>
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To build a hybrid mobile application, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>Flutter</li>
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To store data into databases, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>MySql</li>
                        <li>Postgresql</li>
                        <li>MongoDB</li>
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        To deploy or implement CI/CD pipeline, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>GitHub Actions</li>
                        {/* <li>Jenkins</li> */}
                        {/* <li>Bash Scripts</li> */}
                    </ul>
                </div>
                <div className='w-full flex flex-col items-center'>
                    <p className='w-full text-black text-sm text-left py-2'>
                        When I am in need of cloud services, I would choose them:
                    </p>
                    <ul className='pl-4 list-disc text-left w-full text-sm text-black'>
                        <li>Amazon Web Services</li>
                        <li>Google Cloud Platform</li>
                        <li>Google Firebase</li>
                        <li>Supabase</li>
                    </ul>
                </div>
            </div>
        </div>
        <p onClick={() => {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }} className='w-full text-right py-2 text-sm underline text-black cursor-pointer'>Back to top</p>
    </div>
  )
}

export default Technology